module.exports = __webpack_public_path__ + "img/dashboard_more_icon.ad183884.svg";